import { Collapse } from '@mui/material';
import React, { useState } from 'react';

interface TitleProps {
	isOpen: boolean;
}

interface Props {
	title: (props: TitleProps) => React.ReactNode;
	content: React.ReactNode;
}

const CustomAccordian = ({ title, content }: Props) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	return (
		<div>
			<div onClick={() => setIsOpen(!isOpen)} className="cursor-pointer">
				{title({ isOpen })}
			</div>
			<Collapse in={isOpen}>{content}</Collapse>
		</div>
	);
};

export default CustomAccordian;
